<template>
  <section class="protected_section">
    <div class="container text-center">
      <h4>Please enter password to access this page.</h4>

      <div class="row">
        <div class="col-md-12">
          <form v-on:submit.prevent="validateBeforeSubmit">
            <div class="form-group text-left">
              <div class="form_field">
                <input class="form-control password-field" type="password" name="password" v-model.trim="password" :placeholder="error">
              </div>
              <div class="form_btn">
                <button class="btn btn-primary" type="submit">Submit</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {

  data () {
    return {
      error: null,
      password: null
    }
  },
  methods: {
    validateBeforeSubmit(){
      if( this.password == '' || this.password == null)
      {
        this.error = 'Field is required'
      }
      else{

        if(this.password === 'EnterMoonshot01')
        {
          let route = this.$route;
          localStorage.setItem('user-password', true)
          this.$router.push(`/${route.params.password}`)
        }
        else{
          this.error = 'Invalid Password';
        }
      }

      this.password = '';
    }
  }

}
</script>

<style>
  section.protected_section {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
  }
  section.protected_section h4 {
    margin-bottom: 20px;
  }
  section.protected_section .form-group.text-left {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 520px;
    margin: auto;
  }
  section.protected_section .form-group.text-left div.form_field {
    display: flex;
    align-items: center;
    width: 80%;
    margin-right: 10px;
  }
  section.protected_section .form-group.text-left input.form-control.password-field {
    padding: 13.5px 20px;
    font-size: 15px;
    width: 100%;
    border: 2px solid #fff;
    border-radius: 0;
    outline: none;
    color: #000;
    font-family: "GTAmerica-expanded", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  }

  section.protected_section .form-group.text-left input.form-control.password-field::placeholder{
    color: red;
  }
  section.protected_section .form-group.text-left input.form-control.password-field::selection{
    color: #000;
    background: #f19762;
  }
  section.protected_section .form-group.text-left div.form_btn {
    width: 20%;
    text-align: center;
  }
  section.protected_section .form-group.text-left div.form_btn button {
    width: 100%;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 1px;
    padding: 15px 0;
    border: 2px solid #ffffff;
    color: #000;
    border-radius: 0;
    background: linear-gradient(180deg,#fff,#fff 25%,hsla(0,0%,100%,0) 50%,hsla(0,0%,100%,0));
    background: -webkit-gradient(linear,left top,left bottom,from(#fff),color-stop(25%,#fff),color-stop(50%,hsla(0,0%,100%,0)),to(hsla(0,0%,100%,0)));
    outline: none;
    cursor: pointer;
    font-family: "GTAmerica-expanded", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    transition: background-position .4s cubic-bezier(.23,1,.32,1);
    -webkit-transition: background-position .4s cubic-bezier(.23,1,.32,1);
    background-size: 400% 400%;
    background-position: 0 0;
    text-transform: uppercase
  }
  section.protected_section .form-group.text-left div.form_btn button:hover {
    background-position: 0 100%;
    color: #fff;
  }
</style>
